import {
  CIFARelationCreateFormState,
  CIFARelationRaw,
} from "@/domain/CIFARelation";
import { API_CLIENT } from "../config";

const apiUrlCIFARelations = "/admin/ci_fa_relations";

export const getAdminCIFARelations = async (): Promise<CIFARelationRaw[]> => {
  const response = await API_CLIENT.get<{ items: CIFARelationRaw[] }>(
    apiUrlCIFARelations
  );
  return response.data.items;
};

export const postAdminCreateCIFARelation = async ({
  ciFARelationCreateFormState,
}: {
  ciFARelationCreateFormState: CIFARelationCreateFormState;
}): Promise<CIFARelationRaw> => {
  const response = await API_CLIENT.post<{ item: CIFARelationRaw }>(
    apiUrlCIFARelations,
    {
      ...ciFARelationCreateFormState,
    }
  );
  return response.data.item;
};

export const postAdminRemoveCIFARelation = async ({
  faMasterId,
}: {
  faMasterId: string;
}): Promise<void> => {
  await API_CLIENT.post(
    `${apiUrlCIFARelations}/${encodeURIComponent(faMasterId)}/remove`
  );
};
